import { Link } from "react-router-dom";
import Rating from "./Rating";
import Price from "./Price";
import { useEffect, useRef, useState } from "react";

export default function Book({ book }) {
  const [img, setImg] = useState();

  useEffect(() => {
    let isActive = true;

    const image = new Image();
    image.src = book.url;

    image.onload = () => {
      setTimeout(() => {
        if (isActive) {
          setImg(image);
        }
      }, 1200);
    };
    return () => {
      isActive = false;
    };
  }, [book.url]);

  return (
    <div className="book">
      {img ? (
        <>
          <Link to={`/books/${book.id}`} className="book__img--link">
            <figure className="book__img--wrapper">
              <img
                src={img.src}
                alt={`${book.title} image`}
                className="book__img"
              />
            </figure>
          </Link>
          <div className="book__title">
            <Link to={`/books/${book.id}`} className="book__title--link">
              {book.title}
            </Link>
          </div>
          <Rating rating={book.rating} />
          <div className="book__price">
            <Price
              salePrice={book.salePrice}
              originalPrice={book.originalPrice}
              displayMode="and"
            />
          </div>
        </>
      ) : (
        <>
          <div className="book__img--skeleton"></div>
          <div className="skeleton book__title--skeleton"></div>
          <div className="skeleton book__rating--skeleton"></div>
          <div className="skeleton book__price--skeleton"></div>
        </>
      )}
    </div>
  );
}
